import axios from 'axios';
import { getDataOptions, postDataOptions } from './backendServices';
import { COURSE_SERVICE_BASE_URL } from './environments';

// CME WEBINAR APIs
const GET_WEBINAR_DETAILS_API = 'webinar/getDetails/';
const FORUM_DISCUSSION_ASK_API = 'admin/userQuery/ask';
const USER_COURSE_ENROL_API = 'course/enroll';
const WEBINAR_REGISTER_API = 'webinar/user/register';
const UPDATE_PROGRESS_API = 'course/updateProgress';
const WEBINAR_LIVE_ATTENEDED_API = 'webinar/user/liveAttended';
const GET_WEBINAR_SESSION_TIME_API = 'webinar/sessionTime';

// Services
export const getWebinarService = async (webinarID) => {
  try {
    const response = await axios(getDataOptions(COURSE_SERVICE_BASE_URL, GET_WEBINAR_DETAILS_API + webinarID), true);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const askForumQuestionAutoService = async (payload) => {
  try {
    const response = await axios(postDataOptions(COURSE_SERVICE_BASE_URL, FORUM_DISCUSSION_ASK_API, payload));
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const userCouresEnrolService = async (payload) => {
  try {
    const response = await axios(postDataOptions(COURSE_SERVICE_BASE_URL, USER_COURSE_ENROL_API, payload));
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const webinarRegisterService = async (payload) => {
  try {
    const response = await axios(postDataOptions(COURSE_SERVICE_BASE_URL, WEBINAR_REGISTER_API, payload));
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const updateProgressService = async (payload) => {
  try {
    const response = await axios(postDataOptions(COURSE_SERVICE_BASE_URL, UPDATE_PROGRESS_API, payload));
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const webinarLiveAttenededService = async (payload) => {
  try {
    const response = await axios(postDataOptions(COURSE_SERVICE_BASE_URL, WEBINAR_LIVE_ATTENEDED_API, payload));
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const webinarSessionService = async (userId, webinarId) => {
  try {
    const payload = {
      userId: userId,
      timeInMinutes: 2,
      webinarId: webinarId,
    };
    const response = await axios(postDataOptions(COURSE_SERVICE_BASE_URL, GET_WEBINAR_SESSION_TIME_API, payload));
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
};
